import React, { useState, useEffect } from "react";

// components
import BlogItem from "../BlogItem/BlogItem";

// styles
import styles from "./styles.module.scss";

const BlogList = ({ blogList }) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    if (blogList) {
      let filter = blogList.filter((item) => item.BlogId !== 3);

      setList(filter);
    }
  }, [blogList]);

  // console.log(blogList);

  return (
    <div className={styles.blog__list}>
      {list.map((item) => (
        <BlogItem key={item.id} data={item} />
      ))}
    </div>
  );
};

export default BlogList;
